export type MessageBlock = {
  type: 'text' | 'tool_call' | 'tool_result'
  content: string
  toolName?: string
  toolId?: string
}

export function parseMessageBlocks(rawContent: string): MessageBlock[] {
  let parsed: unknown = rawContent

  try {
    parsed = JSON.parse(rawContent)
  } catch {
    parsed = [{ type: 'text', text: rawContent }]
  }

  const blocks = Array.isArray(parsed) ? parsed : [parsed]

  return blocks
    .map((block: any) => {
      if (!block) return null
      if (block.type === 'text') {
        return { type: 'text' as const, content: block.text || '' }
      }
      if (block.type === 'tool_use') {
        return {
          type: 'tool_call' as const,
          content: JSON.stringify(block.input || {}, null, 2),
          toolName: block.name,
          toolId: block.id,
        }
      }
      if (block.type === 'tool_result') {
        let content = ''

        if (block.output !== undefined) {
          content =
            typeof block.output === 'string'
              ? block.output
              : JSON.stringify(block.output, null, 2)
        } else if (block.content !== undefined) {
          if (typeof block.content === 'string') {
            content = block.content
          } else if (Array.isArray(block.content)) {
            content = block.content
              .map((entry: any) => {
                if (entry && typeof entry === 'object') {
                  if ('text' in entry && typeof entry.text === 'string') {
                    return entry.text
                  }
                  try {
                    return JSON.stringify(entry, null, 2)
                  } catch {
                    return String(entry)
                  }
                }
                return entry ?? ''
              })
              .filter(Boolean)
              .join('\n')
          } else {
            try {
              content = JSON.stringify(block.content, null, 2)
            } catch {
              content = String(block.content)
            }
          }
        }

        content = content.trim()
        if (!content || content === '{}') {
          return null
        }

        return {
          type: 'tool_result' as const,
          content,
          toolName: block.name ?? 'result',
          toolId: block.tool_use_id ?? block.id,
        }
      }
      if (block.type === 'json') {
        return {
          type: 'tool_call' as const,
          content: JSON.stringify(block.data ?? {}, null, 2),
          toolName: 'json',
        }
      }
      return null
    })
    .filter((block): block is MessageBlock => Boolean(block) && block.content !== '')
}
